import {
  ActivateLeadEventData,
  AddPaymentInfoEventData,
  AddShippingInfoEventData,
  ApplyCouponEventData,
  BeginCheckoutEventData,
  ChangeConfigurationEventData,
  GenerateLeadEventData,
  ITrackingService,
  PurchaseEventData,
  SelectProductEventData,
  ViewConfigurationEventData,
  ViewConfigurationSummaryEventData,
  ViewProductEventData,
  ViewProductListEventData,
} from '../types';
import { GoogleTagManager } from './GoogleTagManager';
import GtmEventBuilder from './GtmEventBuilder';
import { GtmEventName } from './types';

export class GoogleTrackingService implements ITrackingService {
  public constructor(private readonly manager: GoogleTagManager) {}

  public trackActivateLead(data: ActivateLeadEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.ActivateLead, data }));
  }

  public trackGenerateLead(data: GenerateLeadEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.GenerateLead, data }));
  }

  public trackViewConfiguration(data: ViewConfigurationEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.DefaultConfiguration, data }));
  }

  public trackChangeConfiguration(data: ChangeConfigurationEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.ConfigurationChange, data }));
  }

  public trackViewConfigurationSummary(data: ViewConfigurationSummaryEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.ConfigurationSummary, data }));
  }

  public trackViewProductList(data: ViewProductListEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.ViewItemList, data }));
  }

  public trackSelectProduct(data: SelectProductEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.SelectItem, data }));
  }

  public trackViewProduct(data: ViewProductEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.ViewItem, data }));
  }

  public trackBeginCheckout(data: BeginCheckoutEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.BeginCheckout, data }));
  }

  public trackApplyCoupon(data: ApplyCouponEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.ApplyCoupon, data }));
  }

  public trackAddShippingInfo(data: AddShippingInfoEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.AddShippingInfo, data }));
  }

  public trackAddPaymentInfo(data: AddPaymentInfoEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.AddPaymentInfo, data }));
  }

  public trackPurchase(data: PurchaseEventData): void {
    this.manager.send(GtmEventBuilder.build({ name: GtmEventName.Purchase, data }));
  }
}
